import * as React from 'react';
import { DatePicker } from '@app/src/components/DatePicker';
import { Field } from '@app/src/components/Field';

export const RenderDatePicker = ({
  label,
  portionWidth,
  type,
  errorMessage,
  input,
  minDate,
  ...rest
}) => {
  return(
    <Field
      label={label}
      portionWidth={portionWidth}
      errorMessage={errorMessage}
    >
      <DatePicker
        readOnly
        type={type}
        uncontrolled
        date={input.value}
        minDate={minDate}
        {...input}
        {...rest}
        error={!!errorMessage}
      />
    </Field>
  );
};
